<template>
  <base-link
    v-bind="linkProps"
    :class="{
      [$style.container]: true,
      ...computedClasses,
    }"
    :style="getStyles"
    @click="$emit('click')"
  >
    <slot />
  </base-link>
</template>

<script>
import buttonMixin from 'lib/mixins/buttonMixin';
import BaseLink from 'atoms/base/BaseLink';

const INTERNAL_LINK_PROPS = Object.keys(BaseLink.props);

// TODO: CPME-3857 Добавить возможность открытия внутренних ссылок (router-link)
export default {
  name: 'LinkButton',
  mixins: [
    buttonMixin,
  ],
  components: {
    BaseLink,
  },
  props: {
    ...BaseLink.props,
  },
  computed: {
    linkProps() {
      const filteredProps = Object.keys(this.$props)
        .filter(prop => INTERNAL_LINK_PROPS.includes(prop))
        .reduce((obj, key) => {
          obj[key] = this.$props[key];
          return obj;
        }, {});

      return filteredProps;
    },
  },
};
</script>

<style lang="sass" module>
  @import '~sass/components/button'
</style>
